import React, { useState, useEffect } from "react";
import { IoFilterOutline } from "react-icons/io5";

import { DasboardTopBar, DashboardWrapper } from "./dashboardPage.styled";
import Button from "../../components/button";
import StatsBoxOne from "../../components/statsBox/statsBoxOne";
import { subscriptionData } from "./constant/subscriptionData";
import { comapnyData } from "./constant/mokData";
import { CEPDashboardStatsType } from "../../types/paymentTypes";
import { getCepDashboardStatsReq } from "../../api/dashboard/cepDashboardStatsReq";
import AES from "crypto-js/aes";

const noImage = require("../../assets/images/no-picture-available-icon-1.jpg");

export const CEP_DashboardPage = () => {
  const [dashStatsDetails, setdashStatsDetails] =
    useState<CEPDashboardStatsType>();

  const cepDashboardStatsList = async () => {
    try {
      const res = await getCepDashboardStatsReq();
      const _dashboardStats = {
        numberOfCandidateOffers: res?.data?.numberOfCandidateOffers,
        numberOfCandidates: res?.data?.numberOfCandidates,
        numberOfCompanies: res?.data?.numberOfCompanies,
        numberofCardsets: res?.data?.numberofCardsets,
        numberOfAcceptedCandidates: res?.data?.joinedCandidatesCount,
        joinersPercentage: res?.data?.joinersPercentage,
        numberOfDeclinedCandidates: res?.data?.dropoutCandidatesCount,
        declinersPercentage: res?.data?.dropoutPercentage,
        companyDetails: res?.data?.companyDetails,
      };
      setdashStatsDetails(_dashboardStats);
    } catch (error) {
      // toast.error(error?.errMessage);
    }
  };

  const toCompanyDetails = async ({ companyID }: { companyID: number }) => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      const roleIs = localStorage.getItem("@role");
      const userId = localStorage.getItem("userID");
      const encriptdataIs = AES.encrypt(
        JSON.stringify({
          companyID,
          refreshToken,
          roleIs,
          userId,
        }),
        "vmzCareerX"
      ).toString();
      const _encriptdataIs = encriptdataIs.replaceAll("/", "$");
      console.log(encriptdataIs.replaceAll("/", "$"), "encrypted token");
      const domainUrl = process.env.REACT_APP__EADMIN_DOMAIN;
      // const domainUrl = "http://localhost:3000";
      console.log("URL", domainUrl + "/from-padmin/loading/" + _encriptdataIs);

      window.location.href =
        domainUrl + "/from-padmin/loading/" + _encriptdataIs;
    } catch (error) {}
  };

  useEffect(() => {
    cepDashboardStatsList();
  }, []);

  return (
    <DashboardWrapper className="p-2">
      <DasboardTopBar className="px-4 py-2">
        <div className="bar_title">
          <p className="lg-text">
            <b>Summary</b>
            <span>(all clients)</span>
          </p>
        </div>
        <div>
          <Button
            outline
            className={"mx-3 px-3"}
            label="Active/All Time"
            borderColor="secondary"
            onClick={() => {}}
          />
        </div>
        <div className="">
          <IoFilterOutline color="#3A93F4" size={25} className="" />
        </div>
        <div className="px-2"></div>
      </DasboardTopBar>

      <div className="d-flex p-3">
        {/* {statsData1.map((item, idx) => (
          <StatsBoxOne
            key={idx}
            label={item.label}
            numbers={item.numbers}
            desc={item.desc}
            inPercentage={item.inPercentage}
            inRupees={item.inRupees}
            className="mx-2"
          />
        ))} */}
        <StatsBoxOne
          label={"Job Offers"}
          numbers={dashStatsDetails?.numberOfCandidateOffers || 0}
          desc={""}
          inPercentage={false}
          inRupees={false}
          className="mx-2"
        />
        <StatsBoxOne
          label={"Candidates"}
          numbers={dashStatsDetails?.numberOfCandidates || 0}
          desc={""}
          inPercentage={false}
          inRupees={false}
          className="mx-2"
        />
        <StatsBoxOne
          label={"Companies"}
          numbers={dashStatsDetails?.numberOfCompanies || 0}
          desc={""}
          inPercentage={false}
          inRupees={false}
          className="mx-2"
        />
        <StatsBoxOne
          label={"Engagement Score"}
          numbers={0}
          desc={""}
          inPercentage={false}
          inRupees={false}
          className="mx-2"
        />
        <StatsBoxOne
          label={"CardSets"}
          numbers={dashStatsDetails?.numberofCardsets || 0}
          desc={""}
          inPercentage={false}
          inRupees={false}
          className="mx-2"
        />
      </div>
      <div className="d-flex p-3">
        {/* {statsData2.map((item, idx) => (
          <StatsBoxOne
            key={idx}
            label={item.label}
            numbers={item.numbers}
            desc={item.desc}
            inPercentage={item.inPercentage}
            inRupees={item.inRupees}
            className="mx-2"
          />
        ))} */}
        <StatsBoxOne
          label={"Joiners"}
          numbers={dashStatsDetails?.joinersPercentage || 0}
          desc={""}
          presentValue={dashStatsDetails?.numberOfAcceptedCandidates}
          totalValue={dashStatsDetails?.numberOfCandidates}
          presentValueLabel="Joiners"
          totalValueLabel="Out of"
          inPercentage={true}
          inRupees={false}
          className="mx-2"
        />
        <StatsBoxOne
          label={"Drop-outs"}
          numbers={dashStatsDetails?.declinersPercentage || 0}
          desc={``}
          presentValue={dashStatsDetails?.numberOfDeclinedCandidates}
          totalValue={dashStatsDetails?.numberOfCandidates}
          presentValueLabel="Drop-outs"
          totalValueLabel="Out of"
          inPercentage={true}
          inRupees={false}
          className="mx-2"
        />
      </div>
      <div className="p-3">
        <div className="px-2">
          <p className="lg-text">
            <strong>Click to manage an account</strong>
          </p>
        </div>
        <div className="bg-white border d-flex flex-1 m-2 p-2 row">
          {dashStatsDetails?.companyDetails?.map((item, idx) => (
            <div key={idx} className="col-lg-4 p-0">
              <div key={idx} className="border rounded m-2 p-2">
                <div className="d-flex justify-content-between">
                  <p className="sm-text text-success">
                    <strong className="text-capitalize">
                      {item.companyName}
                    </strong>
                  </p>
                  <p className="sm-text text-success">
                    <strong className="text-capitalize">{item.Status}</strong>
                  </p>
                </div>
                <div className="logo_box mt-1 ">
                  <div style={{ height: "100%", width: "70%" }}>
                    <img
                      src={
                        item?.companyWebLogoURL
                          ? item?.companyWebLogoURL
                          : noImage
                      }
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <ul>
                    {/* {item?.summary.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))} */}
                    <li key={idx}>
                      {item.userCount ? item.userCount : 0} users
                    </li>
                    <li key={idx}>
                      {item.activeOfferedCandidatesCount
                        ? item.activeOfferedCandidatesCount
                        : 0}{" "}
                      Active offers
                    </li>
                    <li key={idx}>
                      {item.candiadteCount ? item.candiadteCount : 0} Candidates
                    </li>
                    <li key={idx}>0 E.Score%</li>
                  </ul>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="sm-text text-success">
                    <strong className="text-capitalize"></strong>
                  </p>

                  <button
                    className="sm-text border border-0 bg-white p-0 text-success"
                    onClick={() =>
                      toCompanyDetails({ companyID: item?.companyID })
                    }
                  >
                    <strong className="text-capitalize">{"Manage"}</strong>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardWrapper>
  );
};
